import type { DipPeekTarget, DipPeekType } from "~/features/dataImportProjects/types";
import { v2Route } from "~/v2/routes";

export function peekPathFor(
  type: DipPeekType,
  id: string,
  dataImportProjectId: string,
  initialTab?: DipPeekTarget["initialTab"],
): string {
  switch (type) {
    case "dataSource":
      return v2Route.dataImportProjects.detail.dataSource.$buildPath({
        params: { id: dataImportProjectId, dataSourceId: id },
      });
    case "evidenceSet":
      return v2Route.dataImportProjects.detail.evidenceSet.$buildPath({
        params: { id: dataImportProjectId, evidenceSetId: id },
      });
    case "batchEvidencesJob":
      return v2Route.dataImportProjects.detail.batchEvidencesJob.$buildPath({
        params: { id: dataImportProjectId, jobId: id },
      });
    // Drafts have no dedicated route; the peek id is the owning BEJob, so fall back to its detail page.
    case "evidenceDrafts":
      return v2Route.dataImportProjects.detail.batchEvidencesJob.$buildPath({
        params: { id: dataImportProjectId, jobId: id },
      });
    case "batchChangeRequestsJob":
      return v2Route.dataImportProjects.detail.batchChangeRequestsJob.$buildPath({
        params: { id: dataImportProjectId, jobId: id },
      });
    // Peek-only types: deep-link the DIP detail with the peek open. `{type, id}` is all the
    // URL carries, which is exactly what these panels need.
    case "entityComposer":
    case "relationComposer":
    case "recordUpdateComposer":
    case "evidenceImporter":
      return v2Route.dataImportProjects.detail.$buildPath({
        params: { id: dataImportProjectId },
        searchParams: { peekType: type, peekId: id, peekTab: initialTab },
      });
    // A records peek also needs its BCR job and record kind, which the URL cannot carry,
    // so land on the project instead of a peek that would open empty.
    case "records":
      return v2Route.dataImportProjects.detail.$buildPath({ params: { id: dataImportProjectId } });
  }
}
